import { Link, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import type { AuthUser } from '@/lib/hooks/useAuth'

const API = import.meta.env.VITE_API_URL ?? 'http://localhost:3001'

const navItems = [
  {
    href: '/dashboard',
    label: 'Dashboard',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/>
        <rect width="7" height="9" x="14" y="12" rx="1"/><rect width="7" height="5" x="3" y="16" rx="1"/>
      </svg>
    ),
    exact: true,
  },
  {
    href: '/missions',
    label: 'Mes missions',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
      </svg>
    ),
    exact: false,
    excludes: ['/missions/nouvelle'],
  },
  {
    href: '/missions/nouvelle',
    label: 'Nouvelle mission',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><path d="M12 8v8m-4-4h8"/>
      </svg>
    ),
    exact: true,
    accent: true,
  },
  {
    href: '/documents',
    label: 'Documents',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
        <line x1="10" y1="9" x2="8" y2="9"/>
      </svg>
    ),
    exact: false,
    excludes: [] as string[],
  },
  {
    href: '/formations',
    label: 'Demandes formation',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
      </svg>
    ),
    exact: false,
    excludes: [] as string[],
  },
  {
    href: '/catalogue',
    label: 'Catalogue formations',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
      </svg>
    ),
    exact: false,
    excludes: [] as string[],
  },
  {
    href: '/analytics',
    label: 'Analytics',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
    exact: true,
    excludes: [] as string[],
  },
  {
    href: '/parametres',
    label: 'Paramètres',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
        <circle cx="12" cy="12" r="3"/>
      </svg>
    ),
    exact: true,
  },
  {
    href: '/guide-entreprise',
    label: 'Guide d\'utilisation',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>
      </svg>
    ),
    exact: true,
    excludes: [] as string[],
  },
] as const

interface SidebarProps {
  user: AuthUser
  onLogout: () => void
}

const REQUIRED_DOC_KEYS = ['KBIS', 'ASSURANCE', 'RIB']

export function Sidebar({ user, onLogout }: SidebarProps) {
  const pathname = useLocation().pathname
  const [unreadChat, setUnreadChat] = useState(0)
  const [docsComplete, setDocsComplete] = useState<boolean | null>(null)

  useEffect(() => {
    const token = localStorage.getItem('velink_token')
    if (!token) return

    async function fetchUnread() {
      try {
        const r = await fetch(`${API}/api/missions/messages/unread-count`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        if (r.ok) {
          const { count } = await r.json()
          setUnreadChat(count)
        }
      } catch { /* silencieux */ }
    }

    fetchUnread()
    const t = setInterval(fetchUnread, 10000)
    return () => clearInterval(t)
  }, [])

  useEffect(() => {
    const token = localStorage.getItem('velink_token')
    if (!token) return

    Promise.all([
      fetch(`${API}/api/companies/me/documents`, { headers: { Authorization: `Bearer ${token}` } }),
      fetch(`${API}/api/companies/me`, { headers: { Authorization: `Bearer ${token}` } }),
    ])
      .then(async ([docsRes, profileRes]) => {
        const docs = docsRes.ok ? await docsRes.json() : []
        const profile = profileRes.ok ? await profileRes.json() : null
        const uploadedTypes = new Set((docs as { type: string }[]).map((d) => d.type))
        const hasSiret = !!profile?.siret
        const hasAllDocs = REQUIRED_DOC_KEYS.every((k) => uploadedTypes.has(k))
        setDocsComplete(hasSiret && hasAllDocs)
      })
      .catch(() => {})
  }, [pathname])

  function isActive(item: (typeof navItems)[number]) {
    if ('excludes' in item && item.excludes?.some((e) => pathname.startsWith(e))) return false
    if (item.exact) return pathname === item.href
    return pathname.startsWith(item.href)
  }

  return (
    <aside className="fixed left-0 top-0 bottom-0 w-60 flex flex-col z-40 border-r border-white/[0.08] bg-[rgba(10,10,20,0.75)] backdrop-blur-2xl">
      {/* Logo */}
      <div className="px-5 pt-6 pb-5 border-b border-white/[0.08]">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl bg-accent/20 border border-accent/30 flex items-center justify-center flex-shrink-0">
            <span className="text-accent font-bold">V</span>
          </div>
          <div>
            <p className="text-text-primary font-semibold text-sm leading-tight">Velink</p>
            <p className="text-text-muted text-xs">Espace entreprise</p>
          </div>
        </div>
      </div>

      {/* Badge dossier incomplet */}
      {docsComplete === false && (
        <div className="px-3 pt-3">
          <Link
            to="/documents"
            className="flex items-center gap-2 px-3 py-2 rounded-xl bg-[#F59E0B]/10 border border-[#F59E0B]/30 hover:bg-[#F59E0B]/20 transition-all group"
          >
            <span className="text-[#F59E0B] text-sm">⚠️</span>
            <div className="min-w-0">
              <p className="text-[#F59E0B] text-xs font-semibold leading-tight">Dossier incomplet</p>
              <p className="text-[#F59E0B]/60 text-[10px] truncate">Documents manquants →</p>
            </div>
          </Link>
        </div>
      )}

      {/* Retour au site */}
      <div className="px-3 pt-3">
        <Link
          to="/"
          className="flex items-center gap-2 px-3 py-2 rounded-xl bg-accent/10 border border-accent/25 hover:bg-accent/20 transition-all text-accent font-semibold text-sm group"
        >
          <span className="group-hover:-translate-x-0.5 transition-transform">←</span>
          Retour au site
        </Link>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => {
          const active = isActive(item)
          const showChatBadge = item.href === '/missions' && unreadChat > 0
          const showDocsBadge = item.href === '/documents' && docsComplete === false
          return (
            <Link
              key={item.href}
              to={item.href}
              className={[
                'flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200',
                'accent' in item && item.accent
                  ? 'bg-accent/15 border border-accent/20 text-[#8B9AFF] hover:bg-accent/25 hover:border-accent/35'
                  : active
                    ? 'bg-white/[0.10] border border-white/[0.12] text-text-primary'
                    : 'text-text-secondary hover:bg-white/[0.06] hover:text-text-primary border border-transparent',
              ].join(' ')}
            >
              <span className="flex-shrink-0 relative">
                {item.icon}
                {showChatBadge && (
                  <span className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-accent text-white text-[9px] font-bold flex items-center justify-center">
                    {unreadChat > 9 ? '9+' : unreadChat}
                  </span>
                )}
              </span>
              {item.label}
              {showDocsBadge && (
                <span className="ml-auto w-2 h-2 rounded-full bg-[#F59E0B] flex-shrink-0" />
              )}
              {showChatBadge && (
                <span className="ml-auto px-1.5 py-0.5 rounded-full bg-accent/15 border border-accent/25 text-accent text-[10px] font-bold flex-shrink-0">
                  {unreadChat} msg
                </span>
              )}
            </Link>
          )
        })}
      </nav>

      {/* User + Logout */}
      <div className="px-3 pb-4 border-t border-white/[0.08] pt-4">
        <div className="px-3 py-2 mb-1.5 glass-card rounded-xl">
          <p className="text-text-primary text-xs font-medium truncate">{user.email}</p>
          <p className="text-text-muted text-[10px] mt-0.5">
            Entreprise ·{' '}
            {docsComplete === false ? (
              <span className="text-[#F59E0B]">Dossier incomplet</span>
            ) : docsComplete === true ? (
              <span className="text-success">Dossier complet</span>
            ) : 'Chargement…'}
          </p>
        </div>
        <button
          onClick={onLogout}
          className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium w-full text-left text-text-secondary hover:bg-danger/10 hover:text-danger transition-all duration-200 border border-transparent"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          Déconnexion
        </button>
      </div>
    </aside>
  )
}
